import type { RenderInput } from '@str/shared';

/**
 * How loud the reel's own sound sits under music the host added. Filmed reels carry the place's
 * natural sound now (rain, a fire, birds; the content API reports `media.hasAudio`), so a song
 * goes over it rather than replacing it; the slider still takes it to zero or full.
 */
export const ORIGINAL_UNDER_MUSIC = 0.25;

/** The levels a reel plays and renders at until the host moves a slider. */
export function defaultReelSound(withMusic: boolean): NonNullable<RenderInput['sound']> {
  return { originalVolume: withMusic ? ORIGINAL_UNDER_MUSIC : 1, musicVolume: 1, musicStartMs: 0 };
}
